import React from 'react';
import ProductCard from './Batches';
import './Batches.css';

// Import images
import product1 from '../../Images/Bolo Bindass.png';
import product2 from '../../Images/Abacus.png';
import product3 from '../../Images/Vedic Math.png';
import product4 from '../../Images/Tech Gurukul.png';
import product5 from '../../Images/Class-6.png';
import product6 from '../../Images/Class-7.png';
import product7 from '../../Images/Class-8.png';
import product8 from '../../Images/Class-9.png';
import product9 from '../../Images/Class-10.png';
import product10 from '../../Images/Class-11.png';
import product11 from '../../Images/Class-12.png';

const MultipleProductCards = () => {
  const products = [
    { id: 1, image: product5, name: 'Pratham Prayas (Class-6)', startDate: '09 Dec 2024', monthlyfee: '1199/-', billedamount: '5999/-',explorePath: '/Pratham-Prayas' },
    { id: 2, image: product6, name: 'Chhattrapati (Class-7)', startDate: '09 Dec 2024', monthlyfee: '1199/-', billedamount: '5999/-', explorePath: '/Chhattrapati' },
    { id: 3, image: product7, name: 'Ashtveer (Class-8)', startDate: '09 Dec 2024', monthlyfee: '1299/-', billedamount: '6499/-', explorePath: '/Ashtveer' },
    { id: 4, image: product8, name: 'Nauvi ke Sikandar (Class-9)', startDate: '09 Dec 2024', monthlyfee: '1499/-', billedamount: '7499/-', explorePath: '/Nauvi-ke-Sikandar' },
    { id: 5, image: product9, name: 'Dasvi ke Dangal (Class-10)', startDate: '09 Dec 2024', monthlyfee: '1499/-', billedamount: '7499/-', explorePath: '/Dasvi-ke-Dangal' },
    { id: 6, image: product10, name: 'Vigyaan ki Udaan (Class-11)', startDate: '09 Dec 2024', monthlyfee: '1599/-', billedamount: '7999/-', explorePath: '/Vigyaan-ki-Udaan' },
    { id: 7, image: product11, name: 'Final Orbit (Class-12)', startDate: '09 Dec 2024', monthlyfee: '1599/-', billedamount: '7999/-', explorePath: '/Final-Orbit' },
    { id: 8, image: product1, name: 'Bolo Bindass (Class-4-8)', startDate: '09 Dec 2024', fullamount: '2999/-',explorePath: '/bolo-bindass' },
    { id: 9, image: product2, name: 'Brain-O-Meter (Class 1-6)', startDate: '09 Dec 2024', fullamount: '4999/-',explorePath: '/brain-o-meter' },
    { id: 10, image: product3, name: 'Gurukul Ganit (Class-1-6)', startDate: '09 Dec 2024', fullamount: '2999/-',explorePath: '/gurukul-ganit' },
    { id: 11, image: product4, name: 'Tech Gurukul (Class-6-10)', startDate: '09 Dec 2024', fullamount: '2999/-',explorePath: '/tech-gurukul' },
  ];

  return (
    <div className="batches-section">
      <h1 className="section-heading">Our Batches</h1>
      <div className="product-card-container">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

export default MultipleProductCards;
